<template>
  <div class="px-4">
    <div class="my-10 mx-auto">
      <client-auth-preface
        :user="user"
        :contact="contact"
        :company="company"
        :project="project"
        @continue="step = 'code'"
        v-if="step === 'preface'"
      />
      <client-auth-code
        :company="company"
        :project="project"
        :contact="contact"
        v-if="step === 'code'"
      />
    </div>
  </div>
</template>

<script>
import Avatar from "../../UI/Avatar.vue"
import ClientAuthPreface from "../components/ClientAuthPreface.vue"
import ClientAuthCode from "../components/ClientAuthCode.vue"

export default {
  name: "Auth",

  components: { ClientAuthCode, ClientAuthPreface, Avatar },

  data() {
    const data = window.FinancialCents.data

    return {
      contact: { ...data.contact },
      client: { ...data.client },
      company: { ...data.company },
      project: { ...data.project },
      user: { ...data.user },
      step: "preface",
    }
  },
}
</script>

<style scoped></style>
